import { ADD_FILTER, RESET_FILTERS, SAVE_FILTERS, TOGGLE_MENU } from 'actions/dashboard';
import { combineReducers } from 'redux';

/**
 * @param {DashboardUiState} [state]
 * @param {Action} [action]
 * @returns {DashboardUiState}
 */
const uiReducer = (state = {}, action = { type: '', payload: {} }) => {
  const { type } = action;
  switch (type) {
    case TOGGLE_MENU:
      return { ...state, isSideMenuOpen: !state.isSideMenuOpen };
    case SAVE_FILTERS:
      return { ...state, isSideMenuOpen: false };
    default:
      return state;
  }
};

/**
 * @param {DashboardDomainState} [state]
 * @param {Action} [action]
 * @returns {DashboardDomainState}
 */
const domainReducer = (state = {}, action = { type: '', payload: {} }) => {
  const { type, payload } = action;
  switch (type) {
    case RESET_FILTERS:
      return { ...state, filters: {} };
    case SAVE_FILTERS:
      return { ...state, filters: payload };
    case ADD_FILTER:
      return { ...state, filters: { ...state.filters, ...payload } };
    default:
      return state;
  }
};

const dashboardReducer = combineReducers({ domain: domainReducer, ui: uiReducer });

/** Reducer that combines domain and app reducer */
export default dashboardReducer;
